import { action, makeObservable, observable } from 'mobx';
import { splitNormalizedSearchTerms } from 'utils/textSearch';

export class UiSourceSearchStore {
  searchesById: Record<string, string> = {};
  settingsMenuById: Record<string, boolean> = {};
  autofocusSearch: boolean = false;
  showOnlyUnusedRowsById: Record<string, boolean> = {};

  constructor() {
    makeObservable(this, {
      autofocusSearch: observable,
      setSearchFocus: action.bound,
      searchesById: observable,
      setSearchString: action.bound,
      settingsMenuById: observable,
      openSettingsMenu: action.bound,
      closeSettingsMenu: action.bound,
      showOnlyUnusedRowsById: observable,
      toggleShowOnlyUnusedRows: action.bound,
    });
  }

  getHasSearch = (sourceId: string) => !!this.searchesById[sourceId]?.trim();

  getSearchTerms = (sourceId: string) => {
    return splitNormalizedSearchTerms(this.searchesById[sourceId]);
  };

  setSearchString(sourceId: string, value: string) {
    this.searchesById[sourceId] = value;
  }

  setSearchFocus(value: boolean) {
    this.autofocusSearch = value;
  }

  openSettingsMenu(sourceId: string) {
    this.settingsMenuById[sourceId] = true;
  }

  closeSettingsMenu(sourceId: string) {
    this.settingsMenuById[sourceId] = false;
  }

  isSettingsMenuOpen = (sourceId: string) => !!this.settingsMenuById[sourceId];

  toggleShowOnlyUnusedRows(sourceId: string) {
    this.showOnlyUnusedRowsById[sourceId] = !this.showOnlyUnusedRowsById[sourceId];
  }

  clearAllSearches() {
    this.searchesById = {};
  }
}
